import React, { useState } from 'react'
import { Table } from '@mantine/core'
import { SelectWithTable } from 'app/views/components/inputs/selects/CustomSelectWithTable'
import { Note } from 'app/models/note-params'
import 'app/styles/components/notes.css'



interface Props {
    notes: Note[]
    setSelectedNote: (note: Note) => void
    setIsViewOnly: (isViewOnly: boolean) => void
}

export default function NotesFilterHeader({ notes, setSelectedNote, setIsViewOnly }: Props) {
    const [searchValue, setSearchValue] = useState('') // State to control the search filter
    const [dropdownOpen, setDropdownOpen] = useState(false) // State to control dropdown visibility

    const filteredNotes = notes.filter(note => {
        // Filter by title, text, tags (joined by commas), or date
        const isMatchingText = note?.title?.toLowerCase().includes(searchValue.toLowerCase()) ||
            note?.text?.toLowerCase().includes(searchValue.toLowerCase()) ||
            (note?.tags?.join(',').toLowerCase().includes(searchValue.toLowerCase())) ||
            note?.createDate?.includes(searchValue) ||
            note?.text?.includes(searchValue)

        return isMatchingText
    })


    return (
        <div className='notes-filter-header'>
            <div className='notes-filter-search-wrapper'>
                <SelectWithTable
                    disabled={false}
                    searchValue={searchValue}
                    open={dropdownOpen}
                    setOpen={setDropdownOpen}
                    setSearchValue={setSearchValue}
                    position='bottom-end'
                    withArrow={false}
                >
                    <div className='notes-filter-table-container'>
                        <div className='tradeTableScroll'>
                            <Table highlightOnHover className="tradeTable">
                                <thead>
                                    <tr>
                                        <th>Note Title</th>
                                        <th>Author</th>
                                        <th>Keywords</th>
                                        <th>Date Added</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredNotes.map(note => (
                                        <tr
                                            key={note.id}
                                            onClick={() => {
                                                setSelectedNote(note) // Set the selected note when clicked
                                                setIsViewOnly(true)  // Set isViewOnly to true
                                                setDropdownOpen(false) // Close the dropdown after selection
                                            }}
                                            className='note-table-body-row'
                                        >
                                            <td>{note.title}</td>
                                            <td>LendOS User</td>
                                            <td>{note?.tags?.join(', ')}</td>
                                            <td>{note.createDate}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>

                </SelectWithTable>
            </div>
        </div>
    )
}